let childrenRoutes = []
const paths = require.context('../domains/', true, /routes.js$/i)
const context = paths.keys().map(paths).map(m => m.default)

context.map((arr) => {
    if (arr) {
        arr.map((val) => { childrenRoutes.push(val) })
    }
})

const routes = [
    {
        path: '/parceiro',
        component: () => import('@/shared/components/layout/Interno'),
        children: childrenRoutes,
    },
    {
        path: '/parceiro/cadastro',
        alias: '/parceiro/cadastro',
        component: () => import('../domains/cadastro/views/Cadastro'),
        meta: { 
            public: true 
        }
    },
]

export default routes